import React, { Component } from 'react';
import qs from 'qs';
import { RETAILER_ID, SSO_REDIRECT_URL } from "../../config";

class WakefernSSO extends Component {

    constructor(props) {
        super(props);
        this.receiveMessage = this.receiveMessage.bind(this);
    }

    componentDidMount() {
        const {
            setLoading
        } = this.props;
        window.addEventListener("message", this.receiveMessage, false);
        setLoading(true);
        if (window.parent) {
            console.log("SSO: parent exists, sso data requested")
            window.parent.postMessage('wfc-page-loaded', '*');
        }
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.receiveMessage, false);
    }

    receiveMessage(event) {
        const {
            createNewUserOrSignIn,
            history
        } = this.props;
        console.debug("SSO: receiveMessage(event)")
        console.debug(event)
        // Do we trust the sender of this message?
        if (!event || typeof event.data !== 'object') {
            console.debug("SSO: no event found or data isn't an object")
            return;
        }

        const data = event.data
        if (data && data.source && data.source.indexOf('devtools') !== -1){
            console.log('SSO: Ignoring dev tool message')
            return
        }

        // {
        //   customerIdentified: boolean,
        //       email: string,
        //     firstName: string,
        //     frequentShoppingNumber: string,
        //     pseudoStoreId: string
        // }

        if (!data || !data.customerIdentified || !data.frequentShoppingNumber) {
            console.log("SSO: data is not a json or user not authenticated")
            // var url = (window.location !== window.parent.location)
            //     ? document.referrer
            //     : document.location.href;
            // if (!url) {
            //     url = '/downtimedollars'
            // }
            // const returnUrl = encodeURIComponent(url);
            // console.log('RETURN URL = ', returnUrl);
            // console.log(`REDIRECT URL = ${SSO_REDIRECT_URL + returnUrl}`)
            window.top.location.href = SSO_REDIRECT_URL; // complete redirect
            return
        }
        const loyaltyNum = data.frequentShoppingNumber
        const email = data.email
            return createNewUserOrSignIn(loyaltyNum, RETAILER_ID)
                .then(() => setTimeout((isNewUser) => {
                    console.log('new User ' + isNewUser)
                    console.debug(`User created/signed in with loyalty number ${loyaltyNum}`);
                    console.log("SAML: User Already seen Tutorial = " + window.localStorage.getItem("adjoy_seenTutorial"))
                    if (isNewUser !== true) history.push('/app/campaigns');
                    else history.push('/app/tutorial');
                }, 1500))
                .catch((err) => {
                    console.log('WakefernSSO failed to get a user.');
                    console.log(err);
                    history.push('/');
                });
    }

  render() {
    return <div></div>;
  }
}

export default WakefernSSO;



// WEBPACK FOOTER //
// ./src/pages/WakefernSSO/WakefernSSO.js